import React from 'react';
import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-react';

/**
 * Placeholder Create Segment Data Table modal.
 *
 * CR1 wires the button + visibility + the onSubmit→list-refresh seam, but the body is a stub.
 * CR2 fills it in (Table name, Segment to segregate on, Segment Population fields per the
 * "Create Segment Data Table" mockup) and calls CreateSegmentDataTable, invoking onSubmit(tableId)
 * on success. Prop shape mirrors the CLI CreateTableModal so CR2 is a drop-in replacement.
 */
export default function SegmentCreateModal(props: { visible: boolean, onCancel: () => void, onSubmit: (tableId: string) => void }) {
    const { visible, onCancel } = props;
    return (
        <Modal
            visible={visible}
            onDismiss={onCancel}
            closeAriaLabel="Close modal"
            header="Create Segment Data Table"
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button variant="link" onClick={onCancel}>Cancel</Button>
                        <Button variant="primary" disabled>Next: Add columns</Button>
                    </SpaceBetween>
                </Box>
            }
        >
            <Box color="text-body-secondary">The create flow is added in the next change.</Box>
        </Modal>
    );
}
